import React, { memo } from 'react';

import { MyCheckbox } from './checkbox';

export const Checkbox = ({ onKeyDown, ...props }) => {
  return <MyCheckbox onKeyDown={onKeyDown} {...props} />;
};
